export interface SorcDictionaryDto {
  market: string;
  code: string;
  value: string;
}

export enum SorcDictionariesKeys {
  transmissiontype = 'transmissiontype',
  fueltype = 'fueltype',
  bodytype = 'bodytype',
  segmentation = 'segmentation',
  drivetype = 'drivetype',
  co2effclass = 'co2effclass',
  pollutionnorm = 'pollutionnorm',
  fuelenergyclass = 'fuelenergyclass',
}
